// extracted by mini-css-extract-plugin
export default {"container":"MenuLink_container__ks2wZ","link":"MenuLink_link__jnhfG","subMenu":"MenuLink_subMenu__3ukBZ","arrow":"MenuLink_arrow__669wL"};